import { IconButton, styled } from "@mui/material";
import { actionHeaderName } from "../classes.js";
const Chevron = styled(IconButton, {
  name: actionHeaderName,
  slot: "Chevron",
  shouldForwardProp: (prop) => prop !== "ownerState",
  overridesResolver: (_props, styles) => [styles.chevron]
})(({ theme }) => ({
  marginRight: theme.spacing(0.5)
}));
export {
  Chevron
};
//# sourceMappingURL=Chevron.js.map
